import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, catchError, map } from 'rxjs';

import {
  DynamicDocumentFieldInfo,
  DynamicDocumentInfo,
} from '../entities/dynamic-document';

@Injectable({
  providedIn: 'root',
})
export class DynamicDocumentInfoService {
  constructor(private readonly _httpClient: HttpClient) {}

  public getGeneralLabel(
    label: any | Map<string, string> | object,
    lang: string = 'fr_FR'
  ): string {
    try {
      return label.get(lang);
    } catch {
      return label[lang];
    }
  }

  public getLabel(
    dynamicDocument: DynamicDocumentInfo,
    lang: string = 'fr_FR'
  ): string {
    let label: any = '';
    try {
      label = dynamicDocument.label?.get(lang);
    } catch {
      let labels: any = dynamicDocument.label;
      label = labels?.[lang];
    }
    return label;
  }

  public getFieldLabel(
    field: DynamicDocumentFieldInfo,
    lang: string = 'fr_FR'
  ): string {
    let label: any = '';
    try {
      label = field.label?.get(lang);
    } catch {
      let labels: any = field.label;
      label = labels?.[lang];
    }
    return label;
  }

  public findById(
    documentId: string,
    frontOfficeCall: boolean = false
  ): Promise<DynamicDocumentInfo> {
    return new Promise<DynamicDocumentInfo>((resolve, reject) => {
      const options: any = {};
      if (frontOfficeCall) {
        options.headers = new HttpHeaders().append('Frontend-Request', 'true');;
      }
      this._httpClient
        .get<DynamicDocumentInfo>(
          `/dynamic-document-infos/${documentId}`,
          options
        )
        .pipe(
          map((res: any) => {
            resolve(res);
          }),
          catchError((err) => {
            reject(err);
            throw err;
          })
        )
        .subscribe();
    });
  }

  public findByDocumentName(
    documentName: string,
    frontOfficeCall: boolean = false
  ): Observable<any> {
    const options: any = {};
    if (frontOfficeCall) {
      options.headers = new HttpHeaders().append('Frontend-Request', 'true');;
    }
    return this._httpClient.get<DynamicDocumentInfo>(
      `/dynamic-document-infos/by-document-name/${documentName}`,
      options
    );
  }

  public findAll(
    frontOfficeCall: boolean = false
  ): Promise<DynamicDocumentInfo[]> {
    return new Promise<DynamicDocumentInfo[]>((resolve, reject) => {
      const options: any = {};
      if (frontOfficeCall) {
        options.headers = new HttpHeaders().append('Frontend-Request', 'true');;
      }
      this._httpClient
        .get<DynamicDocumentInfo[]>(`/dynamic-document-infos`, options)
        .pipe(
          map((res: any) => {
            resolve(res);
          }),
          catchError((err) => {
            reject(err);
            throw err;
          })
        )
        .subscribe();
    });
  }

  public save(
    document: DynamicDocumentInfo,
    frontOfficeCall: boolean = false
  ): Promise<DynamicDocumentInfo> {
    return new Promise<DynamicDocumentInfo>((resolve, reject) => {
      const options: any = {};
      if (frontOfficeCall) {
        options.headers = new HttpHeaders().append('Frontend-Request', 'true');;
      }
      this._httpClient
        .post<DynamicDocumentInfo>(`/dynamic-document-infos`, document, options)
        .pipe(
          map((res: any) => {
            resolve(res);
          }),
          catchError((err) => {
            reject(err);
            throw err;
          })
        )
        .subscribe();
    });
  }

  public delete(document: DynamicDocumentInfo): Promise<DynamicDocumentInfo> {
    return new Promise<DynamicDocumentInfo>((resolve, reject) => {
      this._httpClient
        .delete<DynamicDocumentInfo>(`/dynamic-document-infos/${document.id}`)
        .pipe(
          map((res) => {
            resolve(res);
          }),
          catchError((err) => {
            reject(err);
            throw err;
          })
        )
        .subscribe();
    });
  }

  public deleteById(id: string): Promise<DynamicDocumentInfo> {
    return new Promise<DynamicDocumentInfo>((resolve, reject) => {
      this._httpClient
        .delete<DynamicDocumentInfo>(`/dynamic-document-infos/${id}`)
        .pipe(
          map((res) => {
            resolve(res);
          }),
          catchError((err) => {
            reject(err);
            throw err;
          })
        )
        .subscribe();
    });
  }
}
